module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c57b9305dfeeffc8d413d486ac4a6c7f.png";